export default "__VITE_ASSET__D59E$00A__"